var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.showNavBar)?_c('nav-bar'):_vm._e(),_c('v-main',{staticClass:"main"},[_c('router-view',{staticClass:"pt-5"})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }